module.exports = __webpack_public_path__ + "static/img/12.e29afef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/12.jpg
// module id = +20X
// module chunks = 1